import { ROUTES } from '@/router/ROUTES';
import STORE from '@/store/STORE';

const { mutations, getters } = STORE;

export default {
  state() {
    return {
      routes: Object.freeze({ ...ROUTES }),
      currentGroup: {},
      routeLoading: false,
      CAN: {
        booking: {
          PM: ['BOOK_TRIAL'],
        },
        trial: {
          PM: ['NEW_TRIAL'],
        },
      },
    };
  },
  getters: {
    [getters.canBooking]: (state) => (action) => {
      const group = state.currentGroup.slug;
      if (!state.CAN.booking[group]) return;
      return state.CAN.booking[group].includes(action);
    },
    [getters.canTrial]: (state) => (action) => {
      const group = state.currentGroup.slug;
      if (!state.CAN.trial[group]) return;
      return state.CAN.trial[group].includes(action);
    },
  },
  mutations: {
    [mutations.setCurrentGroup]: (state, payload) => {
      state.currentGroup = payload;
    },
    [mutations.setRouteLoadingValue]: (state, payload) => {
      state.routeLoading = payload;
    },
  },
  actions: {},
};
